import React from 'react';

const DIThumbsUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="138"
    height="117"
    viewBox="0 0 138 117"
    fill="none"
    {...props}
  >
    <path
      d="M60.4376 53.0076C63.5951 53.0076 66.1671 51.5439 68.279 49.0137L81.0482 33.7492C84.6671 29.4051 87.2848 24.3172 88.7153 18.8472C89.3635 16.3867 90.0675 13.6614 90.7088 11.1104C92.5489 3.74297 110.225 5.12305 108.134 19.8578C106.985 28.5047 104.423 36.9041 100.551 44.7202H127.037C139.778 44.7202 138.593 55.8235 134.857 62.2918C134.114 63.5672 133.69 65.0039 133.623 66.4789C133.557 67.9539 133.848 69.423 134.474 70.7604C135.819 73.6182 134.906 77.4378 133.296 80.0794C132.704 81.0612 132.33 82.1585 132.199 83.2973C132.068 84.436 132.183 85.5896 132.536 86.6801C133.491 89.7051 131.33 93.9917 128.738 96.6474C128.009 97.3943 127.465 98.3017 127.151 99.2967C126.836 100.292 126.759 101.347 126.925 102.377C127.713 107.569 124.834 117.014 116.47 117.014C83.1253 117.014 74.4684 106.426 64.8915 106.426H60.354"
      fill="#FCF6ED"
    />
    <path
      d="M56.7504 48.7558H38.8791C37.2277 48.7558 35.8889 50.0945 35.8889 51.7459V108.608C35.8889 110.259 37.2277 111.598 38.8791 111.598H56.7504C58.4018 111.598 59.7406 110.259 59.7406 108.608V51.7459C59.7406 50.0945 58.4018 48.7558 56.7504 48.7558Z"
      fill="#B3BCC4"
    />
    <path
      d="M27.8594 69.1643C40.0622 69.1643 49.9546 59.2719 49.9546 47.0691C49.9546 34.8663 40.0622 24.9739 27.8594 24.9739C15.6565 24.9739 5.76416 34.8663 5.76416 47.0691C5.76416 59.2719 15.6565 69.1643 27.8594 69.1643Z"
      fill="#39C088"
    />
    <path
      d="M55.97 48.0937C59.1274 48.0937 61.6994 46.6299 63.8183 44.1068L76.5805 28.8353C80.2006 24.4946 82.8185 19.4087 84.2477 13.9402C84.9028 11.4728 85.6417 8.75444 86.2481 6.19642C88.0882 -1.17097 105.764 0.209111 103.673 14.9439C102.524 23.5916 99.9599 31.9913 96.0829 39.8062H122.569C135.318 39.8062 134.126 50.9165 130.39 57.3778C129.648 58.6538 129.225 60.0904 129.158 61.5651C129.092 63.0397 129.382 64.5086 130.006 65.8465C131.352 68.7112 130.445 72.5238 128.828 75.1655C128.237 76.1473 127.863 77.2446 127.732 78.3833C127.601 79.5221 127.716 80.6757 128.069 81.7662C129.024 84.7912 126.87 89.0848 124.27 91.7334C123.544 92.482 123.002 93.3897 122.689 94.3844C122.376 95.3791 122.299 96.4332 122.465 97.4628C123.252 102.656 120.374 112.1 112.01 112.1C78.6646 112.1 70.0077 101.505 60.4308 101.505H55.8933"
      stroke="#48505C"
      strokeWidth="3.62445"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.0026 43.814H52.2757C52.6683 43.814 53.0572 43.8913 53.42 44.0416C53.7827 44.1919 54.1124 44.4121 54.39 44.6898C54.6677 44.9675 54.8879 45.2971 55.0382 45.6599C55.1885 46.0227 55.2658 46.4115 55.2658 46.8042V103.673C55.2603 104.463 54.9428 105.218 54.3827 105.774C53.8225 106.33 53.0651 106.642 52.2757 106.642H34.4113C33.6183 106.642 32.8577 106.327 32.2969 105.767C31.7362 105.206 31.4211 104.445 31.4211 103.652V65.3167"
      stroke="#48505C"
      strokeWidth="3.62445"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.9075 66.648C36.1103 66.648 46.0027 56.7556 46.0027 44.5528C46.0027 32.35 36.1103 22.4576 23.9075 22.4576C11.7046 22.4576 1.81226 32.35 1.81226 44.5528C1.81226 56.7556 11.7046 66.648 23.9075 66.648Z"
      stroke="#48505C"
      strokeWidth="3.62445"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.9363 46.7763L17.6415 53.4746L34.9064 36.2097"
      stroke="white"
      strokeWidth="3.62445"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

DIThumbsUp.displayName = 'DIThumbsUp';

export default DIThumbsUp;
